<template>
    <div class="symbol__text-status">{{status}}</div>
</template>
<script>
    import {mapGetters} from "vuex";
    import unitLmsgMixin from "@/mixins/unitLmsgMixin";

    export default {
        name: 'UnitsList_unit_text_status',
        mixins: [unitLmsgMixin],
        props: {
            unitId: Number,
        },
        data() {
            return {}
        },
        computed: {
            ...mapGetters([
                "getAppUserUnits",
            ]),
            status() {
                let isParked = this.unitLmsgStatus?.isParked
                let isMoving = this.unitLmsgStatus?.isMoving

                if (isParked) return this.$t('text.Parked')
                else if (!isMoving) return ''

                let speed = this.unitSpeed
                if(this.unitMaxSpeed > '') speed += ('/' + this.unitMaxSpeed)
                speed += (' ' + this.getAppUserUnits.speed)

                return speed;
            },
        },
        updated: function() {
           // console.log(`UnitsList_unit_status ${this.status} updated`);
        },
    }
</script>